import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const systemManagementDetailService = (admSeq) => {
  return axiosInstance
    .get(`${ENDPOINTS.ADMIN.SYSTEM.MANAGEMENT.DETAIL}/${admSeq}`)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
